export default __webpack_public_path__ + "e625a88944be39f1f1e84c92c93ff2ce.svg";